/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_No_GroupInputs */

const en_task_flow_item_no_group = /** @type {(inputs: Task_Flow_Item_No_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No group`)
};

const pt_br2_task_flow_item_no_group = /** @type {(inputs: Task_Flow_Item_No_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem grupo`)
};

/**
* | output |
* | --- |
* | "No group" |
*
* @param {Task_Flow_Item_No_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_no_group = /** @type {((inputs?: Task_Flow_Item_No_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_No_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_no_group(inputs)
	return pt_br2_task_flow_item_no_group(inputs)
});